<template>
    <div class="page courses-page py-2 py-lg-6">
        <v-container :class="{'pa-0': phoneOnly}">
            <v-card class="pa-0 transparent" flat>
                <!-- <v-card-title class="py-0">
                    <v-icon color="strong-text" class="me-1">mdi-book-multiple</v-icon>
                    دوراتي
                </v-card-title> -->
                <!-- <v-card-subtitle class="py-0 mb-lg-5">قائمة الدورات التي انضممت لها</v-card-subtitle> -->
                <v-card-text class="py-lg-2 py-0" :class="{'px-0': phoneOnly}">
                    <div v-if="courses && courses.length">
                        <v-row v-if="pcOnly">
                            <v-col cols="12" md="6" lg="3" v-for="(course, i) in courses" :key="course.id + '-' + i" class="px-0 px-md-2 py-2">
                                <course-card short :course="course"> </course-card>
                            </v-col>
                        </v-row>
                        <v-list v-else two-line class="pa-0">
                            <course-list-item v-for="(course, i) in courses" :key="course.id + '-' + i" :course="course" />
                        </v-list>
                    </div>
                    <div v-else class="pa-4 pa-lg-0">
                        <v-alert outlined color="blue-grey" text type="info">لم تنضم إلى أي دورة حتى اﻵن</v-alert>
                    </div>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import InfinityWrapper from '@/components/default/infinity-wrapper'
import CourseCard from '@/components/custom/course-card'
import CourseListItem from '@/components/custom/course-list-item'

export default {
    name: "Courses",
    components: {
        InfinityWrapper,
        CourseCard,
        CourseListItem
    },
    data(){
        return {
            
        }
    },
    computed: {
        ...GlobalComputed,
        courses(){
            return this.$store.state.coursesModule.myCourses;
        },
    },
    watch: {
        
    },
    methods: {
        ...GlobalMethods,
    },
    mounted(){

    }
};
</script>

<style lang="scss">
.v-skeleton-loader__image{
    height: 150px!important;
}
</style>